import { z } from "zod";
import { TIER_PROGRAM_ROW_KINDS } from "../domain";

// Bucket 7 — admin tiers editor. Replaces /app/admin/tiers/_actions.ts.
//
// The legacy Zod schemas (tierProgramCreateSchema, tierProgramUpdateSchema,
// tierCreateSchema, tierUpdateSchema, tierProgramMatrixRowCreateSchema,
// tierProgramMatrixRowUpdateSchema, tierProgramCellUpsertSchema,
// partnerTierAssignSchema) already live in `../domain` and are re-exported
// from `@colab/shared` via the package index. This file only adds the
// request-body schemas for the two endpoints that take a different shape
// than the domain CRUD schemas — the reorder endpoints.

// PATCH /api/admin/tiers/programs/:programId/tiers/order — the whole ordered
// id list, one PATCH per drop. Same DnD convention as bucket 5 forms-field
// reorder; flat (vs. forms' nested sections) because tiers are a flat list
// within a program.
export const tierReorderRequestSchema = z.object({
  orderedIds: z.array(z.string().uuid()).min(1),
});
export type TierReorderRequest = z.infer<typeof tierReorderRequestSchema>;

// PATCH /api/admin/tiers/programs/:programId/rows/order — matrix rows reorder.
// Rows are scoped by row_kind (requirement | benefit) so the request carries
// the kind alongside the ordered ids.
export const tierRowReorderRequestSchema = z.object({
  kind: z.enum(TIER_PROGRAM_ROW_KINDS),
  orderedIds: z.array(z.string().uuid()).min(1),
});
export type TierRowReorderRequest = z.infer<typeof tierRowReorderRequestSchema>;
